const { createSelector } = require('reselect')

const selectAddress = state => state['marketplace.customer'].address

const address = () => createSelector(
  [selectAddress],
  add => add.data,
)

const addressError = () => createSelector(
  [selectAddress],
  add => add.error,
)

const addressLoading = () => createSelector(
  [selectAddress],
  add => add.loading,
)

const selectCreate = state => state['marketplace.customer'].create

const create = () => createSelector(
  [selectCreate],
  crt => crt.data,
)

const createError = () => createSelector(
  [selectCreate],
  crt => crt.error,
)

const createLoading = () => createSelector(
  [selectCreate],
  crt => crt.loading,
)

const selectUpdate = state => state['marketplace.customer'].update

const update = () => createSelector(
  [selectUpdate],
  updt => updt.data,
)

const updateError = () => createSelector(
  [selectUpdate],
  updt => updt.error,
)

const updateLoading = () => createSelector(
  [selectUpdate],
  updt => updt.loading,
)

module.exports = {
  address,
  addressError,
  addressLoading,
  create,
  createError,
  createLoading,
  update,
  updateError,
  updateLoading,
}
